<template>
    <div id="file-upload">
        <button id="featured-button" :class="'btn btn-small btn-block ' + btnClass" @click.prevent="openModal('featured-image-media-library')">
            {{ label }}
        </button>

        <media-library
            name="featured-image-media-library"
            :opened="modalOpened"
            @closedModal="onClosedModal"
            :group="group"
            type="file"
            v-model="files" />

        <div class="modal micromodal-slide" id="squirrel-file-upload" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-image-settings">
                    <div class="modal__content" id="modal-image-settings-content">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import Dropzone from "dropzone";   
    import qs from 'qs';

    export default {
        props: {
            label: {
                type: String,
                default: 'Set featured image',
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                default: null,
            },
            multiple: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: 'media'
            },
            btnClass:{
                type: String,
                default: null
            },
            group: Object,
            filters: Object
        },
        data() {
            return {
                files: [],
                fileList: [],
                modalOpened: false,
                uppyFileUpload: null,
                uppyOptions: {
                    autoProceed: false,
                    providers: [ 'url' ],
                    allowMultipleUploads: true,
                    restrictions: {
                        maxFileSize: 100000000,
                        maxNumberOfFiles: 10,
                        minNumberOfFiles: 1
                    }
                }
            }
        },
        mounted() {
            MicroModal.init({
                disableScroll: true
            });
        },
        methods: {
            updateFromValue() {
                if(this.value !== null){
                    this.filesList = [{
                        url : this.value
                    }];
                }
            },
            removeFile(index) {
                this.filesList.splice(index, 1);
            },
            openModal(modal){
                this.modalOpened = true;
                MicroModal.show(modal);
            },
            onClosedModal(){
                this.modalOpened = false;
                MicroModal.close('featured-image-media-library')
            },
        },
        watch: {
            files(files) {
                let token = document.head.querySelector('meta[name="csrf-token"]');
                if(typeof files[0] !== 'undefined' && token){
                    axios.post('/api/media/create/post', qs.stringify({group: this.group.id, file: files[0].id, category: this.filters.category})).then((response) => {
                        this.$emit('new-file', files[0]);
                        this.fileList.push(files[0]);
                    }, (response) => {
                        this.error = response;
                    });
                    
                }
            },
            value() {
                if(!this.filesList.length) {
                    this.updateFromValue();
                }
            }
        }
    }
</script>